import React from 'react';
import { useNavigate } from 'react-router-dom';

import { BasicDateRangePicker } from 'components';
import { toQueryString } from 'utils';
import { useReportsPageContext } from './reports-page.context';

export const ReportsDateRangePicker = () => {
  const navigate = useNavigate();
  const { buildingId: building, start, end } = useReportsPageContext();

  const onChange = ({ start, end }: { start: string; end: string }) => {
    const qs = toQueryString({ building, start, end });
    navigate(qs ? `?${qs}` : '');
  };

  return <BasicDateRangePicker start={start} end={end} onChange={onChange} />;
};
